import { NetworkProvider } from "../api/api";
import { ErrorData } from "../types";
import MfaType from "./mfa.types";

class Mfa {
  async createMfaTokenUnAuthenticated(
    data: MfaType,
    xMfa?: string
  ): Promise<{
    success: Boolean;
    error?: ErrorData[];
    mfaToken?: { access_token: string; expiry: number };
  }> {
    const networkProvider = NetworkProvider.getInstance();
    let url = `/tokens/mfa`;
    let config = {
      headers: {
        ...(xMfa && { "x-mfa-token": xMfa })
      }
    };
    try {
      var response = await networkProvider.post(url, data, config);

      if (response?.success) {
        return {
          success: true,
          mfaToken: {
            access_token: response?.data?.access_token,
            expiry: response?.data?.expires_in
          }
        };
      } else {
        return { success: false, error: response?.errors as ErrorData[] };
      }
    } catch (e) {}
    return { success: false };
  }

  async createMfaTokenAuthenticated(
    data: MfaType,
    xAuth: string,
    xMfa?: string
  ): Promise<{
    success: Boolean;
    error?: ErrorData[];
    mfaToken?: { access_token: string; expiry: number };
  }> {
    let url = `/accounts/me/tokens/mfa`;
    try {
      const networkProvider = NetworkProvider.getInstance();
      let config = {
        headers: {
          "x-authentication": xAuth,
          ...(xMfa && { "x-mfa-token": xMfa })
        }
      };

      var response = await networkProvider.post(url, data, config);

      if (response?.success) {
        return {
          success: true,
          mfaToken: {
            access_token: response?.data?.access_token,
            expiry: response?.data?.expires_in
          }
        };
      } else {
        return { success: false, error: response?.errors as ErrorData[] };
      }
    } catch (e) {}
    return { success: false };
  }
}

export default Mfa;
